"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var input_1 = require("./input");
Object.defineProperty(exports, "Input", { enumerable: true, get: function () { return input_1.Input; } });
